import React from 'react';
import { Button } from '../Button';
import Page from './Page';
import styles from './Page.module.scss';
import { useNavigate } from 'react-router-dom';

export default function NotFoundPage() {
  const navigate = useNavigate();

  function handleButtonClick() {
    navigate('/');
  }

  return (
    <Page className={styles['page--notFound']}>
      <h1>404: Page not found</h1>
      <div className="body16 darkGrey">
        The page you're looking for could not be found.
      </div>
      <Button primary className="mt-64 pl-36 pr-36" onClick={handleButtonClick}>
        Back to home
      </Button>
    </Page>
  );
}
